import { GrDocumentMissing } from 'react-icons/gr'
import MissingList from './MissingFilesList'
export default {
  list: MissingList,
  icon: GrDocumentMissing,
}
